import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          投稿与合作
        </p>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
              <i className="ri-mail-send-line text-lg"></i>
            </div>
            <div className="flex-1">
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {contactData.description}
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="p-3 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="text-xs text-foreground-400 mb-1">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-800">{contactData.email}</div>
                </div>
                <div className="p-3 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="text-xs text-foreground-400 mb-1">QQ 群号</div>
                  <div className="text-sm font-medium text-foreground-800">{contactData.qq}</div>
                </div>
                <div className="p-3 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="text-xs text-foreground-400 mb-1">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}